"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _react2 = _interopRequireWildcard(require("@monaco-editor/react"));

var _core = require("@jsonforms/core");

var _styles = require("@material-ui/core/styles");

var _solarReact = require("@solar/solar-react");

var _core2 = require("@material-ui/core");

var _ButtonBar = _interopRequireDefault(require("./ButtonBar"));

var _useParsedJson5 = _interopRequireDefault(require("./useParsedJson"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '100%',
      height: '100%',
      borderRight: "solid 1px ".concat(theme.palette.divider)
    },
    flex: {
      alignItems: 'stretch',
      flexGrow: 1
    },
    optionBar: {
      height: 64,
      flexGrow: 0,
      width: '100%',
      justifyContent: 'space-between'
    },
    buttonBar: {
      width: 64,
      flexGrow: 0
    },
    hButtonBar: {
      flexGrow: 0
    }
  };
});
var editorProps = {
  height: '100%',
  width: '100%',
  language: 'json',
  theme: 'vs-dark'
};
var useBgStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      backgroundColor: '#1e1e1e',
      width: '100%'
    }
  };
});

function createDependencyProposals(range) {
  // returning a static list of proposals (filtering is done by the Monaco editor),
  // here you could do a server side lookup
  return [{
    label: '"lodash"',
    kind: _react2.monaco.languages.CompletionItemKind.Function,
    documentation: 'The Lodash library exported as Node.js modules.',
    insertText: '"lodash": "*"',
    range: range
  }, {
    label: '"express"',
    kind: _react2.monaco.languages.CompletionItemKind.Function,
    documentation: 'Fast, unopinionated, minimalist web framework',
    insertText: '"express": "*"',
    range: range
  }, {
    label: '"mkdirp"',
    kind: _react2.monaco.languages.CompletionItemKind.Function,
    documentation: 'Recursively mkdir, like <code>mkdir -p</code>',
    insertText: '"mkdirp": "*"',
    range: range
  }, {
    label: '"my-third-party-library"',
    kind: _react2.monaco.languages.CompletionItemKind.Function,
    documentation: 'Describe your library here',
    insertText: '"${1:my-third-party-library}": "${2:1.2.3}"',
    insertTextRules: _react2.monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
    range: range
  }];
}

var EditorWithBG = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var classes = useBgStyles();

  var registerRef = function registerRef(editor) {
    ref.current = editor;
  }; // useEffect(() => {
  //   const completionDisposable = languages.registerCompletionItemProvider('json', {
  //     provideCompletionItems(model, position) {
  //       // find out if we are completing a property in the 'dependencies' object.
  //       const textUntilPosition = model.getValueInRange({
  //         startLineNumber: 1,
  //         startColumn: 1,
  //         endLineNumber: position.lineNumber,
  //         endColumn: position.column,
  //       });
  //       const match = textUntilPosition.match(
  //         /"dependencies"\s*:\s*\{\s*("[^"]*"\s*:\s*"[^"]*"\s*,\s*)*([^"]*)?$/,
  //       );
  //       if (!match) {
  //         return { suggestions: [] };
  //       }
  //       const word = model.getWordUntilPosition(position);
  //       const range = {
  //         startLineNumber: position.lineNumber,
  //         endLineNumber: position.lineNumber,
  //         startColumn: word.startColumn,
  //         endColumn: word.endColumn,
  //       };
  //       return {
  //         suggestions: createDependencyProposals(range),
  //       };
  //     },
  //   });
  //   return completionDisposable.dispose();
  // }, []);


  return /*#__PURE__*/_react["default"].createElement(_react2["default"], _extends({}, props, {
    onMount: registerRef
  }));
});

var CodeEditor = function CodeEditor(_ref) {
  var formJSON = _ref.formJSON,
      formUIJSON = _ref.formUIJSON,
      formData = _ref.formData,
      classes = _ref.classes,
      onChangeFormJSON = _ref.onChangeFormJSON,
      onChangeFormUIJSON = _ref.onChangeFormUIJSON,
      onChangeFormData = _ref.onChangeFormData,
      onSave = _ref.onSave,
      onRestore = _ref.onRestore,
      isDirty = _ref.isDirty,
      previewEnabled = _ref.previewEnabled,
      onTogglePreview = _ref.onTogglePreview;
  var c = useStyles({
    classes: classes
  });
  var monacoRef = (0, _react.useRef)(); // json, uiJson, data

  var _useState = (0, _react.useState)('json'),
      _useState2 = _slicedToArray(_useState, 2),
      selectedTab = _useState2[0],
      setSelectedTab = _useState2[1];

  var _useParsedJson = (0, _useParsedJson5["default"])(formData),
      _useParsedJson2 = _slicedToArray(_useParsedJson, 2),
      parsedData = _useParsedJson2[0],
      validData = _useParsedJson2[1];

  var _useParsedJson3 = (0, _useParsedJson5["default"])(formJSON),
      _useParsedJson4 = _slicedToArray(_useParsedJson3, 2),
      parsedSchema = _useParsedJson4[0],
      validSchema = _useParsedJson4[1];

  var canCreateSchema = (!formJSON || formJSON === '') && parsedData && validData;
  var canCreateUISchema = (!formUIJSON || formUIJSON === '') && parsedSchema && validSchema;

  var onFormat = function onFormat() {
    // find monaco ref
    if (monacoRef.current) {
      monacoRef.current.getAction('editor.action.formatDocument').run();
    }
  };

  var generateSchema = function generateSchema() {
    // const uischema = Generate.uiSchema(schema);
    var schema = _core.Generate.jsonSchema(parsedData);

    onChangeFormJSON(JSON.stringify(schema, null, 4));
  };

  var generateUISchema = function generateUISchema() {
    var uischema = _core.Generate.uiSchema(parsedSchema);

    onChangeFormUIJSON(JSON.stringify(uischema, null, 4));
  };

  return /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, {
    fullColumn: true,
    classes: {
      root: (0, _clsx["default"])(c.root, c.flex)
    }
  }, /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, {
    classes: {
      root: (0, _clsx["default"])(c.flex, c.optionBar)
    }
  }, /*#__PURE__*/_react["default"].createElement(_core2.Tabs, {
    onChange: function onChange(v, key) {
      setSelectedTab(key);
    },
    value: selectedTab
  }, /*#__PURE__*/_react["default"].createElement(_core2.Tab, {
    key: "json",
    value: "json",
    label: "Form"
  }), /*#__PURE__*/_react["default"].createElement(_core2.Tab, {
    key: "uiJson",
    value: "uiJson",
    label: "Layout"
  }), /*#__PURE__*/_react["default"].createElement(_core2.Tab, {
    key: "jsonData",
    value: "jsonData",
    label: "Data"
  })), /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, {
    classes: {
      root: (0, _clsx["default"])(c.flex, c.hButtonBar)
    }
  }, canCreateSchema && /*#__PURE__*/_react["default"].createElement(_core2.Button, {
    onClick: function onClick() {
      return generateSchema();
    }
  }, "generate Schema"), canCreateUISchema && /*#__PURE__*/_react["default"].createElement(_core2.Button, {
    onClick: function onClick() {
      return generateUISchema();
    }
  }, "generate UI Schema")), /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, {
    classes: {
      root: (0, _clsx["default"])(c.flex, c.hButtonBar)
    }
  }, /*#__PURE__*/_react["default"].createElement(_core2.Button, {
    onClick: function onClick() {
      return onFormat();
    }
  }, "Format"), /*#__PURE__*/_react["default"].createElement(_core2.Button, {
    disabled: !isDirty,
    onClick: function onClick() {
      return onRestore();
    }
  }, "Undo"), /*#__PURE__*/_react["default"].createElement(_core2.Button, {
    disabled: !isDirty,
    onClick: function onClick() {
      return onSave();
    }
  }, "Save"), /*#__PURE__*/_react["default"].createElement(_core2.Button, {
    onClick: function onClick() {
      return onTogglePreview();
    }
  }, previewEnabled ? 'hide' : 'show', " preview"))), /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, {
    classes: {
      root: (0, _clsx["default"])(c.flex)
    }
  }, selectedTab === 'json' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ButtonBar["default"], {
    onClickSnippet: function onClickSnippet(snippet) {
      return console.log(snippet);
    },
    classes: {
      root: c.buttonBar
    }
  }), /*#__PURE__*/_react["default"].createElement(EditorWithBG, _extends({
    ref: monacoRef
  }, editorProps, {
    onChange: onChangeFormJSON,
    value: formJSON,
    defaultValue: "{\n// insert JSON Forms code here\n\n}\n"
  }))), selectedTab === 'uiJson' && /*#__PURE__*/_react["default"].createElement(EditorWithBG, _extends({
    ref: monacoRef
  }, editorProps, {
    onChange: onChangeFormUIJSON,
    value: formUIJSON,
    defaultValue: "{\n// insert JSON UI Forms code here\n\n}\n"
  })), selectedTab === 'jsonData' && /*#__PURE__*/_react["default"].createElement(EditorWithBG, _extends({
    ref: monacoRef
  }, editorProps, {
    onChange: onChangeFormData,
    value: formData,
    defaultValue: "{\n// insert JSON data here\n\n}\n"
  }))));
};

var _default = CodeEditor;
exports["default"] = _default;